import type { ComponentProps, ReactNode } from 'react';

import { cn } from '@/lib/utils';

/**
 * The mono, uppercase, wide-tracked eyebrow above almost every section
 * heading. The brand board's "Label 12 caps +8%".
 */
export function MonoKicker({
    children,
    className,
    ...props
}: ComponentProps<'span'> & { children: ReactNode }) {
    return (
        <span
            {...props}
            className={cn(
                'font-mono text-[12px] leading-none tracking-[0.08em] text-muted-foreground uppercase',
                className,
            )}
        >
            {children}
        </span>
    );
}
